export interface OpenedDialog {
  id: string
  title: string
}

export type ApiInfo = {
  apiUrl: string | null
  apiKey: string | null
}

export enum BotDeployabilityStatus {
  Deployable = 'DEPLOYABLE',
  NotDeployable = 'NOT_DEPLOYABLE',
  Unknown = 'UNKNOWN'
}
